/**
 * Block configuration: adds a Profiles Grid variation to Listing.
 *
 * @module config/blocks
 */
import type { ConfigType } from '@plone/registry';

import ProfilesGridTemplate from '../components/Blocks/Listing/ProfilesGridTemplate';

/** The variation's id, which is what a saved block stores. */
export const PROFILES_GRID_ID = 'profiles-grid';

/** Its label in the variation dropdown. */
export const PROFILES_GRID_TITLE = 'Profiles Grid';

/**
 * Append the Profiles Grid variation to Listing, if it exists.
 *
 * Idempotent and guarded against missing Listing block.
 *
 * @param config The Volto configuration registry.
 * @returns The same registry, for chaining.
 */
export function installVariations(config: ConfigType) {
  const listing = config.blocks.blocksConfig.listing;
  if (!listing?.variations) {
    return config;
  }
  if (
    listing.variations.some((variation) => variation.id === PROFILES_GRID_ID)
  ) {
    return config;
  }
  listing.variations = [
    ...listing.variations,
    {
      id: PROFILES_GRID_ID,
      title: PROFILES_GRID_TITLE,
      template: ProfilesGridTemplate,
    },
  ];
  return config;
}

/**
 * Install all block changes.
 *
 * @param config The Volto configuration registry.
 * @returns The same registry, for chaining.
 */
export default function install(config: ConfigType) {
  installVariations(config);

  return config;
}
